import './edition-cover.css';
import {shortDate} from '../../src/utils/dates.ts';
import type {DigitalEditionListing, PrintEditionListing, ProductData} from '../../types/types.ts';

export function renderPrintEditionCover(editionListing: PrintEditionListing, product: ProductData, locale?: string) {
	return `
<div class="edition-cover-text">
	<a href="/reader/${editionListing._id}">
		<span class="edition-cover-date">${shortDate(editionListing.publishDate, locale)}</span>
		<span class="edition-product-title">${product.attributes.title}</span>
		<span class="edition-title">${editionListing.title}</span>
	</a>
</div>
`;
}

export function renderDigitalEditionCover(editionListing: DigitalEditionListing, product: ProductData) {
	return `
<div class="edition-cover-text">
	<a href="/digital-reader/${editionListing.id}">
		<span class="edition-product-title">${product.attributes.title}</span>
		<span class="edition-cover-date">${editionListing.attributes.title}</span>
	</a>
</div>
`;
}
